import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';
import { ResponseBodyFull } from '@app/models';
import { RelationshipType } from '@app/models/relationship-type';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Helpers } from '@app/helpers/helpers';
import { AuthService } from '@app/auth/_services/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RelationshipTypeService {
  constructor(private http: HttpClient, private authService: AuthService) {}
  private BASE_URL = `${environment.apiUrl}/relationship_types`;

  get() {
    const queryString = `${environment.apiUrl}/relationship_types`;
    if (this.authService.currentUserValue) {
      return this.http.get<ResponseBodyFull<RelationshipType>>(queryString).pipe(map(response => response['hydra:member']));
    } else {
      return new Observable<Array<RelationshipType>>();
    }
  }
  getRelationshipTypes(currentPage = 1, itemsPerPage = environment.defaultItemsCount, filters?) {
    let params = new HttpParams().set('partial', 'false');

    if (currentPage && itemsPerPage) {
      params = params.set('page', currentPage.toString()).set('itemsPerPage', itemsPerPage.toString());
    }

    if (filters) {
      params = Helpers.populateFilters(params, filters);
    }
    return this.http
      .get<ResponseBodyFull<RelationshipType>>(this.BASE_URL, { params })
      .pipe(map(response => ({member: response['hydra:member'], ...response.pagination})));
  }

  addRelationshipType(relationshipType: RelationshipType) {
    const queryString = `${environment.apiUrl}/relationship_types`;
    return this.http.post<RelationshipType>(queryString, relationshipType);
  }

  updateRelationshipType(relationshipType: RelationshipType) {
    const queryString = `${environment.apiUrl}/relationship_types/${relationshipType.id}`;
    return this.http.patch<RelationshipType>(queryString, relationshipType);
  }

  deleteRelationshipType(id: number) {
    const queryString = `${environment.apiUrl}/relationship_types/${id}`;
    return this.http.delete(queryString);
  }
}
